export const locationReload = () => window.location.reload(true);
